import React, { useEffect, useState } from 'react';
import useWindowDimensions from './Dimention';
import { swipeModalWidth } from 'utils/helper';
import SwipeableEdgeDrawer from './SwipeableDrawer';
import { t } from 'i18next';
import { Button, Modal, RadioButton } from 'components';
import { ReportContent } from './Component.style';
import { useDispatch, useSelector } from 'react-redux';
import { getReportListByType } from 'redux/features/DropDownSlice';
import { handleSubmitReportReason } from 'redux/features/SettingsSlice';
import { Notification } from './CustomNotification';

export default function ReportModal({
  resourceType,
  resourceId,
  handleCloseReportModal,
}) {
  const dispatch = useDispatch();
  const { reportReasons } = useSelector((state) => state.DropdownReducer);

  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [reportValue, setReportValue] = useState('');

  useEffect(() => {
    setOpenModal(resourceId);
    setLoading(true);
    dispatch(getReportListByType(resourceType));
  }, [resourceId]);

  useEffect(() => {
    if (reportReasons && reportReasons.length > 0) {
      setLoading(false);
    }
  }, [reportReasons]);

  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const handleClose = (data) => {
    setOpenModal(false);
    setTimeout(() => {
      setReportValue('');
      handleCloseReportModal(data);
    }, 500);
  };

  const handleSubmit = () => {
    dispatch(
      handleSubmitReportReason({
        resourceId,
        resourceType,
        reason: reportValue,
      })
    )
      .then((res) => {
        handleClose({ closePopover: true });
        Notification('success', res.data?.message);
      })
      .catch((err) => {
        Notification('error', err?.response?.data?.message);
        handleClose();
      });
  };

  const handleGetContent = () => {
    return (
      <ReportContent>
        <div className="report-title">Why are you reporting this?</div>
        <div className="report-reasons-list">
          {loading ? (
            <div className="loading">{t('Loading...')}</div>
          ) : (
            <RadioButton
              options={reportReasons}
              value={reportValue}
              onChange={(e) => setReportValue(e.target.value)}
              className="report-radio-button"
            />
          )}
        </div>
        <div className="report-submit-button">
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClose}
            style={{ marginRight: '10px' }}
            label={t('Cancel')}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            label={t('Submit')}
            disableElevation
            disabled={loading}
          />
        </div>
      </ReportContent>
    );
  };

  return (
    <div>
      {isSmallScreen ? (
        <SwipeableEdgeDrawer
          title={t('BusinessPlace.Report')}
          openDrawer={openModal}
          handleCloseDrawer={handleClose}
        >
          {handleGetContent()}
        </SwipeableEdgeDrawer>
      ) : (
        <Modal
          content={handleGetContent()}
          modalchanges={'reportModal'}
          modelTitle={t('BusinessPlace.Report')}
          openModal={openModal}
          handleCancelModal={handleClose}
        />
      )}
    </div>
  );
}
